import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';
import { getCmTrophyNyayPanchayats } from '../../../services/adminApiService/cmTrophyApi/cmTrophyApi';

const CmTrophyNyayPanchayatFilter = ({ className = " ", value, onChange, vidhanSabhaId }) => {
    const [nyayPanchayatList, setNyayPanchayatList] = useState([]);

    useEffect(() => {
        if (!vidhanSabhaId) {
            setNyayPanchayatList([]);
            onChange("");
            return;
        }
        getCmTrophyNyayPanchayats(vidhanSabhaId)
            .then((res) => setNyayPanchayatList(res?.data?.data || []))
            .catch(() => setNyayPanchayatList([]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vidhanSabhaId]);

    return (
        <>
            <div className="">
                <Form.Select
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className={`me-2 ${className}`}
                    style={{ width: "100%", padding: "11px 50px 10px 11px" }}
                    disabled={!vidhanSabhaId}
                > <option value="">All Nyay Panchayat</option>
                    {nyayPanchayatList.map((item) => {
                        return (
                            <option key={item.id} value={item.id}>{item?.name}</option>
                        )
                    })}
                </Form.Select>
            </div>
        </>
    )
}

export default CmTrophyNyayPanchayatFilter
